import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UserInfo from './UserInfo';
import LoginRegister from './LoginRegister';
import './TopBar.css';

// Import TickerFeed directly
import TickerFeed from './TickerFeed.js';

const TopBar = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="top-bar-container">
      <div className="top-bar">
        <div className="logo">
          <Link to="/">
            <div className="logo-container">
              <div className="logo-icon">LR</div>
              <span className="logo-text">Legacy Reborn</span>
            </div>
          </Link>
        </div>
        <div className="user-info-container">
          {isAuthenticated ? <UserInfo /> : <LoginRegister />}
        </div>
      </div>
      <TickerFeed />
    </div>
  );
};

export default TopBar;